module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity-new/header-image-mobile-06-79aa7b529add2a3c567969857a16a90d.jpg";